var map = {
	"./barbecue/placeholder.svg": "vN7j",
	"./dog/placeholder.svg": "NJ/q",
	"./male-walking/placeholder.svg": "xHCf",
	"./skyping/placeholder.svg": "BhU+",
	"./tree/placeholder.svg": "Iz8G"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ieha";